module.exports = __webpack_public_path__ + "assets/img/6a61bb1409c63e83b7b393fe5fd62e2a.png";